import { render, staticRenderFns } from "./AITrainingPanel.vue?vue&type=template&id=e95ac7f4&scoped=true"
import script from "./AITrainingPanel.vue?vue&type=script&lang=js"
export * from "./AITrainingPanel.vue?vue&type=script&lang=js"
import style0 from "./AITrainingPanel.vue?vue&type=style&index=0&id=e95ac7f4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e95ac7f4",
  null
  
)

export default component.exports